<template>
  <v-card>
    <v-card-text>
      <div class="unit-items">
        <div class="unit-title">
          <h3 class="font-weight-regular mb-0 white--text headline" :class="`${color}--text`">
            {{ title }}
          </h3>
          <p class="subtitle-1 ma-0 lh-0">{{ subtitle }}</p>
        </div>
        <template v-if="addItem && mode === 'add'">
          <v-textarea color="amber" v-model="item.title" :rows="1" :autoGrow="true" class="unit-field"
            :hide-details="true" />
          <div class="relative text-right">
            <v-btn light color="amber" class="mt-0 add-button" :disabled="!canSubmit" @click="add">Add</v-btn>
          </div>
        </template>
        <template v-if="addItem && mode === 'edit'">
          <v-textarea color="amber" v-model="item.title" :rows="1" :autoGrow="true" class="unit-field"
            :hide-details="true" />
          <div class="relative text-right">
            <v-btn light color="amber" class="mt-0 add-button" :disabled="!canSubmit" @click="editCommit">Update</v-btn>
          </div>
        </template>

        <draggable class="inner mt-5" :list="items" group="order" @start="startDrag()" @end="endDrag()" :ref="name"
          :id="name">
          <div v-for="(item, index) in items" :key="`unit-${index}`" class="item flexi"
            :data-id="`${Math.round(new Date().getTime() / 1000)}`">
            {{ item.title }}

            <div class="icons" v-if="addItem">
              <v-icon @click="edit(item.id)" class="white--text ma-1">mdi-pencil</v-icon>
              <v-icon @click="remove(item.id)" class="white--text ma-1">mdi-delete-forever</v-icon>
            </div>
          </div>
        </draggable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "PropositionItems",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editIndex: null,
      mode: "add",
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    subtitle: String,
    color: String,
    addItem: {
      type: Boolean,
      default: true,
    },
    editItem: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    draggable,
  },
  computed: {
    canSubmit() {
      const title = this.item && this.item.title;
      return !!(title && String(title).trim());
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.items = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      if (!this.canSubmit) return;
      let item = {
        index: this.items.length,
        title: String(this.item.title).trim(),
        id: new Date().valueOf(),
        type: "content",
      };
      this.items.push(item);
      this.item = {};

      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.$emit("update");
    },
    remove(id) {
      const item = this.items.find((x) => x.id === id);
      if (item) {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      }
    },
    edit(id) {
      const item = this.items.find((x) => x.id === id);
      if (item) {
        this.item = item;
        this.editIndex = this.items.indexOf(item);
        this.mode = "edit";
      }
    },
    editCommit() {
      if (!this.canSubmit) return;
      const updated = {
        ...this.item,
        title: String(this.item.title).trim(),
      };
      this.$set(this.items, this.editIndex, updated);
      this.item = {};
      this.editIndex = null;
      this.mode = "add";
      this.$emit("update");
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      if (div && div.children.length) {
        div.children.forEach((doc) => {
          let item = this.items.find((x) => x.id == doc.dataset.id);
          if (item) {
            let indexOfItem = this.items.indexOf(item);
            item.index = count;
            vm.$set(vm.items, indexOfItem, item);
          }
          count++;
        });
      }
      this.dragging = false;
      this.$emit("update");
    },
  },
};
</script>

<style lang="scss" scoped>
.flexi {
  display: flex;
  justify-content: space-between;

  .icons {
    margin-right: 25px;
  }
}

.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    padding: 0.5rem;
    margin: 0.5rem 0;
    background: #2b2a2a;
    border-radius: 5px;
    color: white;

    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
  }
}

.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}

.unit-field {
  margin: 0.75rem 0 !important;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(120, 120, 120, 0.5) !important;
  color: black !important
}
</style>
